import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = m². */
export const AREA_PIVOT: Record<string, number> = {
  m2: 1,
  mm2: 1e-6,
  cm2: 1e-4,
  km2: 1e6,
  ha: 10000,
  in2: 0.00064516,
  ft2: 0.092903,
  ac: 4046.86,
};

export const transformArea = createPivotTransformer(AREA_PIVOT);
